import { render, staticRenderFns } from "./AtendimentoByLpsList.vue?vue&type=template&id=148f5a65&scoped=true"
import script from "./AtendimentoByLpsList.vue?vue&type=script&lang=js"
export * from "./AtendimentoByLpsList.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoByLpsList.vue?vue&type=style&index=0&id=148f5a65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f5a65",
  null
  
)

export default component.exports